import { render, staticRenderFns } from "./genericError.vue?vue&type=template&id=6ad14d75"
import script from "./genericError.vue?vue&type=script&lang=js"
export * from "./genericError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports